<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_9"></a><a id="file_011">LEON “JAKE” SWIRBUL AND HIS BUSINESS associate, Leroy Grumman, slowly picked their way along the edge of a muddy Long Island roadway. They were looking for metal.</a></p><a id="file_011">
<p class="indent">The metal was for the shop. Their young business was struggling, so they used practically anything they could find. A hammer that slipped off the bumper of a delivery truck became a tool used every day. A solid piece of metal strapping they had liberated now supported a set of new shelves. Something as simple as a shiny silver bolt or washer was scooped up, examined, and slipped into a pocket.</p>
<p class="indent">On a good day, the scavenging pair might find some high-grade hunk of alloy that could be made into something else. Though they didn’t mention such things to their customers, a few fragments of every airplane float and truck body that their company produced were fabricated from hand-me-downs. Even portions of their new fighter plane had come straight out of the ditch.</p>
<p class="indent">With luck on their side, there was no telling what they might find. But for the past few years, it seemed, luck eluded them. As a result, the duo kept a wary eye on the traffic—each half expecting his life to end under the wheels of a wayward freight box or carryall that had strayed too far over to the shoulder of the road.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_011.vue?2a48147a